module.exports = __webpack_public_path__ + "img/2.4acbcd78.jpg";